export default __webpack_public_path__ + "static/media/ikea-homesmart-01.06ed995d.png";